import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import appInfo from '@/helper/appInfo'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: appInfo.config.primary,
            },
            dark: {
                primary: appInfo.config.primary,
            },
        },
    },
});
